import { Slide } from "@jelly/lesson";

import theory from "../../theory";
import linear from "./components/linear";
import dbspl from "./components/db-spl";

const principle: Slide = {
  description:
    "The pressure field radiated by a baffled plane circular piston of radius R and oscillating at a chosen frequency is numerically calculated using the Huygens-Rayleigh integral. The ratio of R over the acoustic acoustic wavelength, i.e. the product of R by the wavevector (k), plays a crucial role in the radiation. For small kR the piston radiates like a half monopole, while for large kR interferences between the half-spherical waves emitted at each point of the oscillating piston (Huygens principle) are seen.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "top",
      controls: [
        {
          type: "button",
          items: [{ name: "Linear" }, { name: "dB SPL" }],
          options: {},
        },
      ],
      extraContent: [[], []],
      components: [linear, dbspl],
    },
  },
};

export default principle;
